import { Injectable } from "@angular/core";

@Injectable()
export class SessionInformationService {
    constructor() { }

    // currentUser() {
    //     return this.getItem("currentUser", true);
    // }

    getItem(key: string, useLocalStorage: boolean = false) {
        var storage = sessionStorage;
        if (useLocalStorage)
            storage = localStorage;

        let value;
        try {
            value = JSON.parse(storage.getItem(key));
        } catch (err) { }

        return value;
    }

    setItem(key: string, value: any, useLocalStorage: boolean = false) {
        var storage = sessionStorage;
        if (useLocalStorage)
            storage = localStorage;

        if (value) {
            if (value instanceof Array) {
                value = value.map((entity) => {
                    delete entity.entityAspect;
                    return entity;
                });
            }
            storage.setItem(key, JSON.stringify(value));
        }
        else
            storage.removeItem(key);
    }

    removeItem(key: string, useLocalStorage: boolean = false) {
        var storage = useLocalStorage ? localStorage : sessionStorage;
        storage.removeItem(key);
    }

    retrieve(key: string, retrieveMethod: () => Promise<any>, useLocalStorage: boolean = false) {
        var value = this.getItem(key, useLocalStorage);
        if (value) {
            return value;
        } else {
            return retrieveMethod().then(data => {
                this.setItem(key, data, useLocalStorage);
                return data;
            });
        }
    }
}
